import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { CustomAutocomplete } from "./AutoComplete";

export  const DepartmentType = ['production', 'sales','account','hr']
export const DepartmentTypeAutoComplete = ({ value, onChange }) => {

  return (
    <CustomAutocomplete
    options={DepartmentType}
    value={value}
    onChange={onChange}
    label="Select Department Type"
  />
  );
};
